<template>
  <div class="mb-4">
    <label class="block text-sm font-medium text-gray-700">{{ label }}</label>
    <div class="flex space-x-2 mt-1">
      <input type="number" v-model.number="localValue" class="border p-1 rounded w-20" />
      <select v-model="selectedUnit" class="border p-1 rounded">
        <option value="sec">Seconds</option>
        <option value="min">Minutes</option>
        <option value="hour">Hours</option>
        <option value="day">Days</option>
        <option value="week">Weeks</option>
        <option value="month">Months</option>
        <option value="year">Years</option>
      </select>
    </div>
    <p class="text-sm text-gray-600 mt-1">Converted: {{ convertedMs }} ms</p>
  </div>
</template>

<script>
export default {
  name: 'TimeDurationInput',
  props: {
    label: {
      type: String,
      required: true,
    },
    // The bound value is in milliseconds.
    modelValue: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      localValue: 0,
      // Default unit is days; if a value already exists, we'll convert it to days.
      selectedUnit: 'day',
    };
  },
  computed: {
    convertedMs() {
      // Convert the local numeric value with the selected unit into milliseconds.
      let ms = 0;
      switch (this.selectedUnit) {
        case 'sec':
          ms = this.localValue * 1000;
          break;
        case 'min':
          ms = this.localValue * 60 * 1000;
          break;
        case 'hour':
          ms = this.localValue * 60 * 60 * 1000;
          break;
        case 'day':
          ms = this.localValue * 24 * 60 * 60 * 1000;
          break;
        case 'week':
          ms = this.localValue * 7 * 24 * 60 * 60 * 1000;
          break;
        case 'month':
          ms = this.localValue * 30 * 24 * 60 * 60 * 1000;
          break;
        case 'year':
          ms = this.localValue * 365 * 24 * 60 * 60 * 1000;
          break;
        default:
          ms = this.localValue * 24 * 60 * 60 * 1000;
          break;
      }
      return ms;
    },
  },
  watch: {
    // When the component is created or when the
    // modelValue changes, convert from milliseconds to days.
    modelValue: {
      immediate: true,
      handler(newVal) {
        if (newVal && typeof newVal === 'number') {
          // Convert the given ms value to days.
          const days = newVal / (24 * 60 * 60 * 1000);
          this.localValue = days;
          this.selectedUnit = 'day';
        }
      },
    },
    // When the computed conversion changes, emit the new ms value.
    convertedMs(newMs) {
      this.$emit('update:modelValue', newMs);
    },
  },
};
</script>

<style scoped>
/* Additional styling if needed */
</style>
